define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi/html"
], function(declare,domClass,html) {
	
	/**
	 * Mixin that makes view occupy 100% height and width of pageContent; should only be used with __Host__ views
	 */
	
	const CSS_FULL = "csi-full";
	
	return declare(null, {
		/**
		 * Modify page center styling to fill 100%
		 */
		onViewCreate: function() {
			domClass.add(html.pageContent(), CSS_FULL);
			this.inherited(arguments);
		},
		
		/**
		 * Reverse effects of full page view
		 */
		uninitialize: function() {
			domClass.remove(html.pageContent(), CSS_FULL);
			this.inherited(arguments);
		}
	});
});